module.exports = __webpack_public_path__ + "static/media/logo_fuse_white.cfa24b39.png";